/* eslint-disable no-dupe-keys */
export default {
  gift_card_redemption_record: {
    name: '兑换记录',
    // 属性（一般与对象内容匹配）
    prop: {
      gift_card_definition: '礼品卡模板',
      serial_number: '礼品卡编号',
      gift_card_name: '礼品卡名',
      status: '状态',
      created_at: '兑换时间',
      user: '兑换用户',
      qrcode: '兑换二维码',
      third_party_order_number: '第三方兑换码',
      coupon_definition: '优惠券',
      charging_card_definition: '充电卡',
      used_coupons_count: '已用优惠券',
      used_charging_cards_count: '已用充电卡',
      created_at: '创建时间',
      redeemed_at: '兑换时间',
      updated_at: '更新时间'
    },
    // Enum的属性
    statuses: {
      redeemed: '已兑换',
      unredeemed: '未兑换'
    },
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_keyword: '礼品卡编号/第三方兑换码'
    }
    // 详情页标签
    // 展开列标题
    // 标签标题
    // 标题
  }
}
